import { brands } from "@/content/siteContent";
import { Reveal } from "./Reveal";

export default function Brands() {
  const items = [...brands.items, ...brands.items];
  return (
    <section id="marcas" className="honeycomb border-y border-metal bg-ink py-20 md:py-24" data-testid="brands-section">
      <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-8">
        <div className="mb-12 text-center">
          <Reveal>
            <div className="mb-4 flex items-center justify-center gap-3">
              <span className="h-px w-8 bg-brand" />
              <p className="microtitle">{brands.microtitle}</p>
              <span className="h-px w-8 bg-brand" />
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-paper sm:text-4xl lg:text-5xl" data-testid="brands-title">
              {brands.titleA}{" "}
              <span className="text-brand">{brands.highlightWord}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-mist md:text-base">{brands.description}</p>
          </Reveal>
        </div>
      </div>

      <Reveal delay={0.2}>
        <div className="brands-marquee relative z-10 overflow-hidden" data-testid="brands-grid">
          <div className="marquee-track brands-track flex w-max items-stretch divide-x divide-metal/60">
            {items.map((brand, i) => (
              <div
                key={`${brand.name}-${i}`}
                aria-hidden={i >= brands.items.length}
                className="flex h-20 w-40 shrink-0 items-center justify-center px-6 md:h-24 md:w-52"
                data-testid={i < brands.items.length ? `brand-tile-${brand.name.toLowerCase()}` : undefined}
              >
                <img
                  src={brand.logo}
                  alt={i < brands.items.length ? `Logo ${brand.name}` : ""}
                  loading="lazy"
                  className="brand-logo max-h-10 w-auto max-w-full object-contain md:max-h-14"
                />
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
